/* Calendar Event Date Time Display Directive
 *
 * Angular Module: trackerbase-app.directives.status-label
 * Directive exposed as "tb-calendar-event-date-time" element.
 */
import angular from "angular";
import CalendarEventDateTimeController from "./CalendarEventDateTimeController";

import CurrentTimeZoneModule from "../../services/CurrentTimeZoneService";
import MomentFormatDateTimeFilterModule from "../../filters/MomentFormatDateFilter";

const calendarEventDateTimeTemplate = require("./CalendarEventDateTime.tpl.html");

let CalendarEventDateTimeComponent = {
    name: "tbCalendarEventDateTime",
    config: {
        bindings: {
            eventStart: "<tbEventStart",
            eventEnd: "<tbEventEnd"
        },
        template: calendarEventDateTimeTemplate,
        controllerAs: "eventDateTimeCtrl",
        controller: CalendarEventDateTimeController
    }
};

export default angular
    .module("trackerbase-app.directives.calendar-event-date-time",[
        CurrentTimeZoneModule,
        MomentFormatDateTimeFilterModule
    ])
    .component(CalendarEventDateTimeComponent.name, CalendarEventDateTimeComponent.config)
    .name;


//////////////////
// WEBPACK FOOTER
// ./src/directives/CalendarEventDateTime/CalendarEventDateTime.js
// module id = 4wUH
// module chunks = 1